import { useState } from 'react';

export default function Features() {
  const [activeStep, setActiveStep] = useState(0);

  const steps = [
    {
      number: '01',
      title: 'Book Your Consultation',
      description: 'Schedule a convenient time to speak with our specialized genetic heart disease experts.',
      icon: 'ri-calendar-check-line',
    },
    {
      number: '02',
      title: 'Expert Assessment',
      description: 'Receive personalized guidance on genetic testing, risk factors, and treatment options.',
      icon: 'ri-stethoscope-line',
    },
    {
      number: '03',
      title: 'Ongoing Support',
      description: 'Get continuous care and monitoring to manage your heart health effectively.',
      icon: 'ri-heart-pulse-line',
    },
  ];

  return (
    <section className="py-12 md:py-24 px-4 sm:px-6 lg:px-20 bg-gradient-to-b from-white to-teal-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 md:mb-6">
            How It Works
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-3xl mx-auto">
            Getting expert care for familial heart disease is simple and straightforward
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 relative">
          {/* Connector lines - hidden on mobile */}
          <div className="hidden md:block absolute top-20 left-0 right-0 h-0.5 bg-gradient-to-r from-teal-200 via-teal-300 to-teal-200 -z-10" 
               style={{ width: 'calc(100% - 120px)', left: '60px' }}></div>

          {steps.map((step, index) => (
            <div
              key={index}
              className={`relative bg-white rounded-2xl p-6 md:p-8 border-2 transition-all duration-300 cursor-pointer ${
                activeStep === index
                  ? 'border-teal-500 shadow-xl shadow-teal-100'
                  : 'border-gray-200 hover:border-teal-300 hover:shadow-lg'
              }`}
              onClick={() => setActiveStep(index)}
            >
              {/* Step number badge */}
              <div className={`absolute -top-4 left-6 md:left-8 w-12 h-12 md:w-14 md:h-14 rounded-full flex items-center justify-center font-bold text-lg md:text-xl transition-all duration-300 ${
                activeStep === index
                  ? 'bg-teal-500 text-white shadow-lg'
                  : 'bg-gray-100 text-gray-400'
              }`}>
                {step.number}
              </div>

              {/* Icon */}
              <div className={`w-14 h-14 md:w-16 md:h-16 rounded-xl flex items-center justify-center mb-4 md:mb-6 mt-6 md:mt-8 transition-all duration-300 ${
                activeStep === index
                  ? 'bg-teal-100'
                  : 'bg-gray-50'
              }`}>
                <i className={`${step.icon} text-2xl md:text-3xl ${
                  activeStep === index ? 'text-teal-600' : 'text-gray-400'
                }`}></i>
              </div>

              {/* Content */}
              <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-3 md:mb-4">
                {step.title}
              </h3>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                {step.description}
              </p>

              {/* Active indicator */}
              {activeStep === index && (
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-teal-400 to-teal-600 rounded-b-xl"></div>
              )}
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <div className="text-center mt-8 md:mt-12">
          <button
            onClick={() => window.REACT_APP_NAVIGATE('/consultation')}
            className="bg-teal-500 hover:bg-teal-600 text-white px-6 md:px-8 py-3 md:py-4 rounded-full font-semibold text-base md:text-lg transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap inline-flex items-center gap-2 min-h-[44px]"
          >
            Book a Free Consultation
            <i className="ri-arrow-right-line text-lg md:text-xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}